import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { InfoForm } from '../helpers/models/info-form.model';
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root',
})
export class VippsStorage {
    constructor(){}

    public isVippsLogin: boolean = false
    public _infoVipps: BehaviorSubject<InfoForm> = new BehaviorSubject(new InfoForm())

    get infoVipps(): InfoForm {
        return this._infoVipps.value;
      }

    setInfo(value: InfoForm = new InfoForm()){
        this._infoVipps.next(value)
    }
}
